import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', 
        display: 'flex', 
        flexDirection: 'column', 
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 18, 
        borderBottom: '1px solid rgba(0,0,0,.3)', 
        width: '100%', 
        textAlign: 'center', 
        paddingTop: 20, 
        paddingBottom: 20
    },
    date: {
        position: 'absolute', 
        top: 10, 
        left: 10, 
        fontSize: 14, 
        color: '#14c0e9'
    },
    bonus_label: {
        position: 'absolute', 
        top: 10, 
        right: 10, 
        fontSize: 14, 
        color: '#3cde0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgb(255, 255, 255,.3)',
        borderRadius: '4px',
        padding: '5px 10px',
        fontWeight: 700
    },
    wrap: {
        padding: '0 20px',
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 5, 
        marginTop: 20
    },
    wrapBlock: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        marginBottom: 8
    },
    helper: {
        color: 'hsla(0,0%,100%,.5)',
        width: 70,
        fontSize: '14px',
        fontFamily: 'PT-sans, sans-serif',
    },
    w100: {
        width: '100%'
    },
}))

const getDate = (value) => {
    const date = new Date(moment.utc(+value))

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const min = date.getMinutes();

    const formatterDay = day < 10 ? '0' + day : day;
    const formatterMonth = month < 10 ? '0' + month : month;
    const formatterHours = hours < 10 ? '0' + hours : hours;
    const formatterMinutes = min < 10 ? '0' + min : min;
    
    return `${formatterDay}.${formatterMonth}.${year} ${formatterHours}:${formatterMinutes}`
}

export {
    getDate,
    useStyles
}